import { useQuickDissolveModsMutation } from '@http';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button';
import { Modal } from '@components/ui/Modal';
import { combineMods } from '@helpers/mods';
import * as Shared from '@shared/lib';
import { useAppStore } from '@stores';

interface ModQuickDissolveProps {
  open: boolean;
  onClose: () => void;
};

export function ModQuickDissolve({ open, onClose }: ModQuickDissolveProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Mods' });
  const { mutateAsync } = useQuickDissolveModsMutation();
  const { userData, isFetching, setIsFetching, refetch } = useAppStore();

  const mods = userData.mods
    .filter(m => !userData.weapons.some(w => w.mods.some(wm => wm.modId === m.id)))
    .filter(m => !userData.chassis.some(c => c.mods.some(cm => cm.modId === m.id)));

  const combinedMods = combineMods(mods, userData);

  const refund = combinedMods
    .filter(m => m.count > 1 && m.rank === 0)
    .reduce((a, b) => a + Shared.DissolveModCalculator.calc(b.level, b.rank) * b.count - 1, 0);

  const dissolve = async () => {
    if (isFetching) return;
    setIsFetching(true);

    await mutateAsync();
    refetch();
    onClose();
  };

  return (
    <Modal title={t('quickDissolveModal')} onRequestClose={onClose} isOpen={open}>
      <div className="flex flex-col items-center p-4">
        <p className="text-sm text-shield">
          {t('quickDissolveModalDescription')}
        </p>

        <Button onClick={dissolve} className="mt-4">
          <div className="w-full flex items-center justify-center">
            <p>{t('dissolveFor')}</p>
            <p className="text-primary ml-1.5">{refund}</p>
            <img src="/assets/items/resonite.avif" className="w-3 h-3 ml-1" />
          </div>
        </Button>
      </div>
    </Modal>
  );
}